import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { USER_TYPES } from '../../constants/userTypes';

/**
 * DashboardRedirect Component
 * 
 * Handles smart redirection for the /dashboard route based on user role.
 */
const DashboardRedirect = () => {
    const navigate = useNavigate();
    const { getUserType, isAuthenticated, isLoading } = useAuth();

    useEffect(() => {
        if (isLoading) return;

        if (!isAuthenticated) {
            navigate('/auth/login', { replace: true });
            return;
        }

        const userType = getUserType();

        switch (userType) {
            case USER_TYPES.ADMIN:
            case USER_TYPES.DEV_ADMIN:
                navigate('/statistics', { replace: true });
                break;

            case USER_TYPES.CONTENT_ADMIN:
                navigate('/admin/dashboard/cms/banners', { replace: true });
                break;

            case USER_TYPES.VETERINARIAN:
            case USER_TYPES.CLINIC_MODERATOR:
                // Redirection logic similar to the "Medical Care" icon in Navbar
                navigate('/medical/clinic/redirect-to-clinic', { replace: true });
                break;

            case USER_TYPES.PET_GUARDIAN:
            case USER_TYPES.SERVICE_PROVIDER:
            default:
                // Default dashboard for general users is the social feed
                navigate('/social', { replace: true });
                break;
        }
    }, [isLoading, isAuthenticated, getUserType, navigate]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontFamily: '"Red Hat Display", sans-serif',
            color: '#64748B'
        }}>
            <div className="loading-spinner" style={{ marginBottom: '20px' }}></div>
            <p>Redirecting to your dashboard...</p>
        </div>
    );
};

export default DashboardRedirect;
